import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Avatar, keyframes } from '@mui/material';
import { SmartToy as AIIcon } from '@mui/icons-material';

const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
  40% { transform: translateY(-4px); opacity: 1; }
`;

const DEFAULT_LABELS = [
  'Thinking…',
  'Coming up with a response…'
];

/**
 * Assistant-style status bubble shown while the AI is working
 * (before any streamed content arrives).
 */
const ThinkingBubble = ({
  labels = DEFAULT_LABELS,
  label,
  icon = <AIIcon />,
  avatarColor = '#1976d2'
}) => {
  const [labelIndex, setLabelIndex] = useState(0);
  const resolvedLabels = label ? [label] : labels;

  useEffect(() => {
    if (resolvedLabels.length <= 1) return undefined;
    const id = setInterval(() => {
      setLabelIndex((i) => (i + 1) % resolvedLabels.length);
    }, 2800);
    return () => clearInterval(id);
  }, [resolvedLabels.length]);

  const statusText = resolvedLabels[labelIndex % resolvedLabels.length];

  return (
    <Box sx={{ display: 'flex', mb: 2, justifyContent: 'flex-start' }}>
      <Avatar sx={{ bgcolor: avatarColor, mr: 1 }}>
        {icon}
      </Avatar>
      <Paper
        elevation={1}
        sx={{
          px: 2,
          py: 1.5,
          maxWidth: '80%',
          bgcolor: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 1.25
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 28 }}>
          {[0, 1, 2].map((i) => (
            <Box
              key={i}
              sx={{
                width: 7,
                height: 7,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                animation: `${bounce} 1.2s ease-in-out infinite`,
                animationDelay: `${i * 0.16}s`
              }}
            />
          ))}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          {statusText}
        </Typography>
      </Paper>
    </Box>
  );
};

export default ThinkingBubble;
